import { WebsocketAction } from '@/lib/hooks/useSocketData';

type BuildWebSocketRequestProps<T = unknown> = {
  action:
    | WebsocketAction.SUBSCRIBE
    | WebsocketAction.UNSUBSCRIBE
    | WebsocketAction.LOGIN
    | WebsocketAction.LOGOUT;
  channel: string;
  data: T;
};
export function buildWebsocketRequest(props: BuildWebSocketRequestProps) {
  return JSON.stringify(props);
}
